import React from 'react';
import Recipe from './Recipe';

// Change the function names and parameters 
// to fit your portfolio topic and schema.

function RecipeList({ recipes, onDelete, onEdit }) {
    return (
        <table id="recipes">
            <caption><strong>Add and Edit Recipes</strong></caption>
            <thead>
                <tr>
                    <th>Title</th>
                    <th>Serves</th>
                    <th>Date</th>
                    <th>Delete</th>
                    <th>Edit</th>
                </tr>
            </thead>
            <tbody>
                {recipes.map((recipe, i) => 
                    <Recipe 
                        recipe={recipe} 
                        key={i}
                        onDelete={onDelete}
                        onEdit={onEdit} 
                    />)}
            </tbody>
        </table>
    );
}

export default RecipeList;
